import {useCallback, useState} from 'react';
import useSWRInfinite from 'swr/infinite';
import URL from '../../../config/url';
import axios from 'axios';
import {
  GroupNodesResponse,
  GroupNodesRequest,
} from '../../../types/deployment/DeploymentDeviceGroup';

type UseDeviceGroupNodes = {
  pageSize?: GroupNodesRequest['size'];
  filter?: GroupNodesRequest['filter'];
  sort?: GroupNodesRequest['sort'];
  onlineOnly?: boolean;
};

export const useDeviceGroupNodes = ({
  pageSize = 5,
  filter,
  sort,
  onlineOnly,
}: UseDeviceGroupNodes) => {
  const [totalCount, setTotalCount] = useState(0);

  const getKey = useCallback(
    (pageIndex: number, previousPageData: GroupNodesResponse | null) => {
      const startFrom = pageSize * pageIndex;
      const totalCount = previousPageData?.body.count;

      if (totalCount && startFrom >= totalCount) {
        return null;
      }

      return URL.GROUP_NODES({
        onlineOnly,
        sort,
        filter,
      });
    },
    [filter, pageSize, sort, onlineOnly]
  );

  const fetcher = useCallback(async function fetcher(url: string) {
    const {data} = await axios.get(url);

    if (data.body.count) {
      setTotalCount(() => data.body.count);
    }

    return data;
  }, []);

  const responses = useSWRInfinite<GroupNodesResponse>(getKey, fetcher);
  const {data, mutate, size, setSize, isValidating} = responses;

  const loadMore = async () => {
    const size = data?.length || 0;
    await setSize(size + 1);
  };

  return {
    totalCount: () => totalCount,
    data,
    mutate,
    size,
    setSize,
    isValidating,
    loadMore,
  };
};
